import React from 'react'
import './how-it-works.css';
export default function HowItWroks() {
  return (
    <div className='how-container'>
        <div className="main-intro">
          <h3>How It Works: Simple and Hassle-Free</h3>
          <p>Our warranties are transferable if you sell your vehicle, adding value for the new owner. If you decide to cancel your warranty early, you may be eligible for a prorated refund based on the time remaining on your contract.</p>
          <button>SEE PLANS</button>
        </div>
        <div className="list">
            <div className="list-box">
              <div className="list-icon">
              <i className='bx bxs-car'></i>
              </div>
              <div className="list-text">
                <p>Start by providing us with your vehicle's make, model, and mileage. This helps us tailor the warranty options specifically to your car's needs.</p>
              </div>
            </div>
            <div className="list-box">
              <div className="list-icon">
              <i className='bx bxs-calendar-check'></i>
              </div>
              <div className="list-text">
                <p>Choose from our range of flexible warranty plans that best suit your driving habits and budget. Each plan is designed to offer comprehensive coverage for critical components.</p>
              </div>
            </div>
            <div className="list-box">
              <div className="list-icon">
              <i className='bx bxl-paypal' ></i>
              </div>
              <div className="list-text">
                <p>Pick a payment plan that works for you, including 0% interest financing options. Whether you prefer to pay upfront or in monthly installments, we’ve got you covered.</p>
              </div>
            </div>
            <div className="list-box">
              <div className="list-icon">
              <i className='bx bxs-key' ></i>
              </div>
              <div className="list-text">
                <p>Once your plan is activated, you can hit the road knowing that you’re protected. Enjoy the confidence of having 24/7 roadside assistance and nationwide coverage.</p>
              </div>
            </div>
        </div>
    </div>
  )
}
